// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1s9t8","consentsList":"PatientConsents_consentsList__1qIgl","consentsListEmpty":"PatientConsents_consentsListEmpty__3if53"};